/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Immacertfileid4Inputs */

const en__field_immacertfileid4 = /** @type {(inputs: _Field_Immacertfileid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enrolment certificate (PDF)`)
};

const de__field_immacertfileid4 = /** @type {(inputs: _Field_Immacertfileid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semester-/Immatrikulations-Bescheinigung (PDF)`)
};

/**
* | output |
* | --- |
* | "Enrolment certificate (PDF)" |
*
* @param {_Field_Immacertfileid4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_immacertfileid4 = /** @type {((inputs?: _Field_Immacertfileid4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Immacertfileid4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_immacertfileid4(inputs)
	return de__field_immacertfileid4(inputs)
});
export { _field_immacertfileid4 as "_field_immaCertFileID" }